<template>
  <div class="content">
    <div class="rotation">
      <div class="rotation_content">
          <el-form :label-position="labelPosition" :rules="rules" label-width="150px" :model="detailList">
            <el-form-item label="题目名称" prop="name">
              <el-input v-model="detailList.name" placeholder="请输入题目名称"></el-input>
            </el-form-item>
            <el-form-item label="题型" prop="type" class="all_width">
              <el-select v-model="detailList.type" filterable placeholder="请选择题型" @change="changeType">
                <el-option :label="item.name" :value="item.id" v-for="(item,index) in typeArr" :key="index"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="选项" class="all_width" v-if="nowType != 4">
              <ul class="judge" v-if="nowType === 1">
                <li v-for="(item,index) in chioceList" :key="index">
                  <el-input v-model="item.name" placeholder="请输入正确选项名称" v-if="item.is_true===1">
                    <template slot="append">
                      <el-button type="success" icon="el-icon-check" circle></el-button>
                    </template>
                  </el-input>
                  <el-input v-model="item.name" placeholder="请输入错误选项名称" v-else>
                    <template slot="append">
                      <el-button type="danger" icon="el-icon-close" circle></el-button>
                    </template>
                  </el-input>
                </li>
              </ul>
              <div class="choice" v-else-if="nowType === 2 || nowType === 3">
                <div class="choice_btn">
                  <el-button type="success" round @click="addRight">+ 添加正确选项</el-button>
                  <el-button type="danger" round @click="addFault">+ 添加错误选项</el-button>
                </div>
                <ul class="choice_ul" ref="choice_ul">
                 <li v-for="(item,index) in chioceList" :key="index">
                    <el-input v-model="item.name" placeholder="请输入正确选项名称" v-if="item.is_true===1">
                      <template slot="append">
                        <el-button type="success" icon="el-icon-check" circle ></el-button>
                      </template>
                    </el-input>
                    <el-input v-model="item.name" placeholder="请输入错误选项名称" v-else>
                      <template slot="append">
                        <el-button type="danger" icon="el-icon-close" circle ></el-button>
                      </template>
                    </el-input>
                    <el-button type="danger" icon="el-icon-delete" circle class="ul_danger" @click="deleteChoice(index)"></el-button>
                  </li>
                </ul>
              </div>
              <div class="subject_other" v-else>请先选择题型</div>
            </el-form-item>
            <el-form-item label="参考答案" class="all_width" v-if="nowType === 4">
              <el-input v-model="detailList.reference_answer" type="textarea" placeholder="请输入参考答案"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSubmit">保存</el-button>
            </el-form-item>
        </el-form>  
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name:'addPeriod',
  components:{
  },
  data(){
    return {
      rules:{
        name :[{required: true, message: '请输入题目名称', trigger: 'blur'}],
        type :[{required: true, message: '请选择题型', trigger: 'change'}],
      },
      labelPosition: 'right',
      typeArr:[],
      nowType:0,
      chioceList:[],
      single:true,
      judgeList:{
        right:'',
        fault:''
      },
      detailList:{}
    }
  },
  created(){
    this.id = this.$route.params && this.$route.params.id
    let inforParams = {
      id:this.id
    }
    this.getInfor(inforParams)
    this.getConfig()
  },
  mounted(){

  },
  methods:{
    getInfor(params){
      this.$api.user.taskSubjectDetail(params)
      .then(res=>{
        if(res.code === 0){
          this.detailList = res.result
          this.nowType = this.detailList.type
          if(this.nowType != 4){
              this.chioceList = this.detailList.option
          }
        }
      }) 
    },
    getConfig(){
      this.$api.user.getConfig()
        .then(res=>{
          if(res.code === 0){
            this.typeArr = res.result.question_type
          }
        }) 
    },
    changeType(val){
      this.nowType = val
      this.chioceList = []
    },
    addRight(){
      if(this.nowType === 2){
        if(this.chioceList.length>0){
          for(let i = 0;i < this.chioceList.length;i++){
            if(this.chioceList[i].is_true === 1){
              this.single = false
              this.$message.error('此题型只能添加一个正确选项')
              break;
            }
          }
          if(this.single){
            this.chioceList.push({name:'',is_true:1})
          }
        }else{
          this.chioceList.push({name:'',is_true:1})
        }
      }
      if(this.nowType === 3){
        this.chioceList.push({name:'',is_true:1})
      }
    },
    addFault(){
      this.chioceList.push({name:'',is_true:0})
    },
    deleteChoice(index){
      if(this.chioceList[index].type === 1){
        this.single = true
      }
      this.chioceList.splice(index,1)
    },
    onSubmit(){
      let op = []
       if(this.nowType != 4){
        op = JSON.stringify(this.chioceList)
      }else{
        op = ''
      }
      let params = {
        id:this.id,
        name: this.detailList.name,
        type:this.detailList.type,//
        option:op,
        reference_answer:this.detailList.reference_answer
      }
      if(!this.detailList.name){
        this.$message.error('请输入题目名称');
      }else if(!this.detailList.type){
        this.$message.error('请选择题型');
      }else{
        this.$api.user.taskSubjectUpdate(params)
          .then(res=>{
            if(res.code === 0){
              this.$message.success('编辑题目成功')
              this.$router.replace({
                path:'/task/taskSubject'
              })
            }
          }) 
        }
    },
  },
}
</script>>
<style lang="scss" scoped>
  @import '../../../assets/scss/content.scss';
  @import '../../../assets/scss/exam.scss';
  
</style>
